/// <reference path="../../app.definition.ts" />

import { Serializable } from "./Serializable";

export class LoggingDetail implements Serializable<LoggingDetail> {
    eventName: string;
    documentId: number;
    startTime: number;
    endTime: number;
    success: boolean;
    combinePdfRequestId: string | null;
    additionalProperties: { [key: string]: any };

    constructor(
        eventName: string,
        documentId: number,
        startTime: number,
        endTime: number,
        success: boolean,
        combinePdfRequestId?: string,
        combineDocIds?: number[],
        error?: any
    ) {
        this.eventName = eventName;
        this.documentId = documentId;
        this.startTime = startTime;
        this.endTime = endTime;
        this.success = success;
        this.combinePdfRequestId = combinePdfRequestId || null;

        this.additionalProperties = {};
        if (combineDocIds) {
            this.additionalProperties["docIds"] = combineDocIds;
        }
        if (error) {
            this.additionalProperties["error"] = error;
        }
    }

    /**
     * Fulfills the 'Serializable' interface contract.
     * Populates the instance with data from a plain object (e.g., from a JSON response).
     * @param input The plain object to deserialize.
     * @returns The current instance of LoggingDetail.
     */
    deserialize(input: any): LoggingDetail {
        this.eventName = input.eventName;
        this.documentId = input.documentId;
        this.startTime = input.startTime;
        this.endTime = input.endTime;
        this.success = input.success;
        this.combinePdfRequestId = input.combinePdfRequestId;
        this.additionalProperties = input.additionalProperties || {};
        return this;
    }
}
